import React, { PropsWithChildren } from 'react';
import { useConnectionErrorHandling } from 'shared/hooks';

export const NetworkStatusProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  useConnectionErrorHandling();
  return <>{children}</>;
};
